import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  GET_VERIFIED_MERCHANT,
  GET_VERIFIED_MERCHANT_COUNT,
  Dashboard_URL_REDIRECT,
  LOGIN_VIA_SUPERADMIN,
  ELASTIC_SEARCH_BASE_URL,
  SECRET_KEY,
} from "../../../Constants/Config";
import { ciBase, ciUrl } from "../../../Constants/nodeCi";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import axios from "axios";

let initialState = {
  loading: false,
  unverifiedMerchantData: [],
  unverifiedMerchantDataCount: 0,
  error: "",
  getDashboardData: [],
};
let IS_ELASTIC_CONNECTED = false;
export const getUnVerifiedMerchant = createAsyncThunk(
  "UnVerified/getUnVerifiedMerchant",
  async (data, { getState, rejectWithValue }) => {
    const state = getState();
    const isElasticConnected = state.permissions.isElasticConnected;
    IS_ELASTIC_CONNECTED = isElasticConnected;
    // let baseurl = isElasticConnected ? ELASTIC_SEARCH_BASE_URL : BASE_URL;
    let baseurl = ciBase(GET_VERIFIED_MERCHANT);
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        baseurl + GET_VERIFIED_MERCHANT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status == 200) {
        // if (baseurl == ELASTIC_SEARCH_BASE_URL && IS_ELASTIC_CONNECTED) {
        if (baseurl) {
          return {
            response: response.data.message,
            // total: response.data.total,    // Uncomment this only when elastic search works. (Undefined if no data found)
          };
        } else {
          return response.data.message;
        }
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getUnVerifiedMerchantCount = createAsyncThunk(
  "UnVerified/getUnVerifiedMerchantCount",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        ciUrl(GET_VERIFIED_MERCHANT_COUNT),
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
        }
      );
      // console.log("unverifiedMerchantDataCount: ", response);
      if (response.data.status == 200) {
        return response.data.data_count;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

//https://sandbox.quickvee.net/Dashboard/login_via_superadmin
export const handleMoveDash = createAsyncThunk(
  "UnVerified/handleMoveDash",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        ciUrl(Dashboard_URL_REDIRECT),
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.status === true) {
        // console.log(response?.data?.stores);

        // Cookies.remove("token_data")
        // Cookies.remove("loginDetails")
        const dataNew = {
          data: response?.data?.data,
          token: response?.data?.token,
          token_id: response?.data?.token_id,
          login_type: response?.data?.login_type,
          final_login: response?.data?.final_login,
          status: response?.data?.status,
        };

        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(dataNew),
          SECRET_KEY
        ).toString();
        // console.log(response?.data?.stores);
        Cookies.set("token_data", encryptedData);
        Cookies.set("loginDetails", response?.data?.stores);
        localStorage.setItem(
          "AllStore",
          JSON.stringify(response?.data?.stores)
        );
      }

      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const UnVerifiedMerchantSlice = createSlice({
  name: "UnVerified",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getUnVerifiedMerchant.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnVerifiedMerchant.fulfilled, (state, action) => {
      state.loading = false;
      if (
        ELASTIC_SEARCH_BASE_URL &&
        ELASTIC_SEARCH_BASE_URL.length &&
        IS_ELASTIC_CONNECTED
      ) {
        state.unverifiedMerchantData = action.payload?.response;
        // state.unverifiedMerchantDataCount = action.payload.total; // Uncomment this only when elastic search works. (Undefined if no data found)
      } else {
        state.unverifiedMerchantData =
          action.payload?.response || action.payload || [];
      }
      state.error = "";
    });
    builder.addCase(getUnVerifiedMerchant.rejected, (state, action) => {
      state.loading = false;
      state.unverifiedMerchantData = {};
      state.error = action.error.message;
    });
    builder.addCase(getUnVerifiedMerchantCount.fulfilled, (state, action) => {
      // if (!IS_ELASTIC_CONNECTED) {
      state.unverifiedMerchantDataCount = action.payload;
      // }
    });
    builder.addCase(getUnVerifiedMerchantCount.rejected, (state, action) => {
      state.unverifiedMerchantDataCount = 0;
    });
    // ==================
    // builder.addCase(handleMoveDash.pending, (state) => {
    //     state.loading = true;
    // })
    // builder.addCase(handleMoveDash.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.getDashboardData = action.payload;
    //     state.error = '';
    // })
    // builder.addCase(handleMoveDash.rejected, (state, action) => {
    //     state.loading = false;
    //     // state.unverifiedMerchantData = {};
    //     state.error = action.error.message;
    // })
    // =================
  },
});
export default UnVerifiedMerchantSlice.reducer;
